const readAll = () => {
  const buttonsMore = document.querySelectorAll('.program__button-read-more');

  if (!buttonsMore) {
    return;
  }

  buttonsMore.forEach((e) => {
    e.addEventListener('click', function (event) {
      let target = event.target;
      target.style.display = 'none';
      let id = target.getAttribute('data-id');
      let text = document.getElementById(id);
      text.style.height = 'auto';
    });
  });
};

export {readAll};
